/* Useit — guided customer assistant (scripted, no external service).
   Checks in with visitors / customers, answers common questions, sends feedback
   through Shopify's contact form. */
(function () {
  'use strict';
  var root = document.querySelector('[data-concierge]');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-cg-config]').textContent); } catch (e) { return; }
  var panel = root.querySelector('[data-cg-panel]');
  var log = root.querySelector('[data-cg-log]');
  var input = root.querySelector('[data-cg-input]');
  var nudge = root.querySelector('[data-cg-nudge]');
  var form = root.querySelector('.concierge__form') || document.getElementById('ConciergeForm');
  var toggles = root.querySelectorAll('[data-cg-toggle]');
  var ls = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var draft = { subject: '', rating: '', body: '' };
  var started = false;
  root.hidden = false;

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function scroll() { log.scrollTop = log.scrollHeight; }
  function say(html, delay) {
    return new Promise(function (resolve) {
      var typing = document.createElement('p');
      typing.className = 'cg-msg cg-msg--bot cg-typing';
      typing.innerHTML = '<span></span><span></span><span></span>';
      log.appendChild(typing); scroll();
      setTimeout(function () {
        typing.className = 'cg-msg cg-msg--bot';
        typing.innerHTML = html;
        scroll(); resolve();
      }, delay == null ? 650 : delay);
    });
  }
  function me(text) {
    var p = document.createElement('p');
    p.className = 'cg-msg cg-msg--me';
    p.textContent = text;
    log.appendChild(p); scroll();
  }
  function choices(list) {
    input.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'cg-choices';
    list.forEach(function (c) {
      var b = document.createElement(c.href ? 'a' : 'button');
      b.className = 'cg-choice';
      if (c.href) { b.href = c.href; } else { b.type = 'button'; }
      b.textContent = c.label;
      if (!c.href) b.addEventListener('click', function () { me(c.label); input.innerHTML = ''; c.go(); });
      wrap.appendChild(b);
    });
    input.appendChild(wrap);
  }
  function stars(next) {
    input.innerHTML = '';
    var wrap = document.createElement('div');
    wrap.className = 'cg-stars';
    [1, 2, 3, 4, 5].forEach(function (n) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cg-star'; b.setAttribute('aria-label', n + ' sur 5');
      b.textContent = '★';
      b.addEventListener('mouseenter', function () { paint(n); });
      b.addEventListener('click', function () { draft.rating = n + '/5'; me('★★★★★'.slice(0, n)); input.innerHTML = ''; next(n); });
      wrap.appendChild(b);
    });
    function paint(n) { Array.prototype.forEach.call(wrap.children, function (x, i) { x.classList.toggle('is-on', i < n); }); }
    wrap.addEventListener('mouseleave', function () { paint(0); });
    input.appendChild(wrap);
  }
  function text(placeholder, next, opts) {
    opts = opts || {};
    input.innerHTML = '';
    var f = document.createElement('form');
    f.className = 'cg-text';
    f.innerHTML = (opts.email ? '<input type="email" required autocomplete="email" placeholder="' + esc(placeholder) + '">' : '<textarea rows="2" placeholder="' + esc(placeholder) + '"' + (opts.required ? ' required' : '') + '></textarea>') +
      '<button type="submit" aria-label="Envoyer"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      (opts.skip ? '<button type="button" class="cg-skip">' + esc(opts.skip) + '</button>' : '');
    var field = f.querySelector('textarea, input');
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = field.value.trim();
      if (!v && opts.required) return;
      if (v) me(v);
      input.innerHTML = '';
      next(v);
    });
    field.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey && field.tagName === 'TEXTAREA') { e.preventDefault(); f.requestSubmit ? f.requestSubmit() : f.dispatchEvent(new Event('submit')); } });
    var skip = f.querySelector('.cg-skip');
    if (skip) skip.addEventListener('click', function () { input.innerHTML = ''; next(''); });
    input.appendChild(f);
    setTimeout(function () { field.focus(); }, 50);
  }

  // ---------------------------------------------------------------- sending
  function send() {
    var email = form.querySelector('[data-cg-field="email"]');
    function go() {
      form.querySelector('[data-cg-field="subject"]').value = draft.subject;
      form.querySelector('[data-cg-field="rating"]').value = draft.rating;
      form.querySelector('[data-cg-field="body"]').value = draft.body || '(sans commentaire)';
      form.querySelector('[data-cg-field="page"]').value = location.pathname;
      ls.set('useit-cg-sent', String(Date.now()));
      say('Merci, je transmets à l\'équipe…', 400).then(function () { form.submit(); });
    }
    if (email.value) { go(); return; }
    say('Votre e-mail, pour que l\'équipe puisse vous répondre ? (il ne sera jamais affiché)').then(function () {
      text('vous@exemple.fr', function (v) { email.value = v; go(); }, { email: true });
    });
  }

  // ---------------------------------------------------------------- flows
  function menu() {
    choices([
      { label: 'Tout va bien 👍', go: happy },
      { label: 'Suivre ma commande', go: tracking },
      { label: 'Un souci avec ma montre', go: defect },
      { label: 'Une idée cadeau', go: gift },
      { label: 'J\'ai une question', go: question }
    ]);
  }
  function happy() {
    draft.subject = 'Expérience client';
    say('Ravi de l\'entendre ! Sur 5, vous nous donnez combien ?').then(function () {
      stars(function (n) {
        var q = n >= 4 ? 'Merci ! Qu\'avez-vous préféré ?' : 'Merci pour votre franchise. Qu\'est-ce qu\'on pourrait améliorer ?';
        say(q).then(function () {
          text('Votre réponse (facultatif)', function (v) {
            draft.body = v;
            if (n >= 4 && cfg.order) {
              say('Si vous avez 1 minute, votre avis aide beaucoup les prochains clients. <a href="' + esc(cfg.links.reviews) + '">Laisser un avis public</a>').then(send);
            } else { send(); }
          }, { skip: 'Passer' });
        });
      });
    });
  }
  function tracking() {
    say(esc(cfg.delivery)).then(function () {
      var list = [{ label: 'Écrire à l\'équipe', go: function () { draft.subject = 'Suivi de commande'; ask('Votre numéro de commande et votre question :'); } }, { label: 'Autre chose', go: menu }];
      if (cfg.customer) list.unshift({ label: 'Voir mes commandes', href: cfg.links.account });
      choices(list);
    });
  }
  function defect() {
    draft.subject = 'Montre défectueuse';
    say(esc(cfg.defect)).then(function () { ask('Décrivez le souci (et votre n° de commande) :', true); });
  }
  function gift() {
    say('Bonne idée ! Avec l\'offre 2 achetées = 2 offertes, beaucoup en gardent une et offrent les autres. Emballage premium et carte écrite à la main disponibles dans le panier.').then(function () {
      choices([
        { label: 'Voir les idées cadeaux', href: cfg.links.gifts },
        { label: 'Voir les packs de 4', href: cfg.links.packs || cfg.links.all },
        { label: 'Autre chose', go: menu }
      ]);
    });
  }
  function ask(prompt, required) {
    say(prompt).then(function () { text('Votre message', function (v) { draft.body = v; send(); }, { required: required !== false }); });
  }
  var FAQ = [
    { k: /livr|délai|delai|recevoir|reçu|recu|colis|suivi|expédi|expedi/i, a: function () { return cfg.delivery; } },
    { k: /retour|rembours|rétract|retract|échang|echang/i, a: function () { return cfg.returns; } },
    { k: /cass|défect|defect|marche pas|fonctionne|panne|pile/i, a: function () { return cfg.defect; } },
    { k: /taille|poignet|grand|petit|mm|diam/i, a: function () { return 'Sur les fiches Héritage et Prisme, le bouton « Essayer à mon poignet » montre la montre à votre tour de poignet. Le bracelet à maillons d\'Héritage se raccourcit chez un bijoutier ou un cordonnier ; ceux de Cosmos et Prisme se règlent sans outil.'; } },
    { k: /étanch|etanch|eau|douche|piscine/i, a: function () { return 'Prisme résiste à la pluie et aux éclaboussures (3 ATM). Pour Héritage et Cosmos, la résistance à l\'eau n\'est pas garantie : évitez tout contact avec l\'eau. Retirez toujours votre montre pour la douche, le bain ou la piscine.'; } },
    { k: /paie|payer|apple|paypal|carte|plusieurs fois|3x|4x/i, a: function () { return 'Paiement 100 % sécurisé : carte, Apple Pay, Shop Pay et PayPal, directement au moment de commander.'; } },
    { k: /cadeau|offrir|emball|carte message/i, a: function () { return 'Vous pouvez ajouter un emballage cadeau premium avec une carte écrite à la main, directement dans le panier.'; } },
    { k: /logo|marque|contrefa|copie/i, a: function () { return 'Nos montres sont sans logo : elles s\'inspirent des grandes familles horlogères sans en reprendre la signature.'; } }
  ];
  function question() {
    say('Je vous écoute : posez votre question.').then(function () {
      text('Ex. : quels sont les délais ?', function (v) {
        var hit = null;
        FAQ.some(function (f) { if (f.k.test(v)) { hit = f; return true; } return false; });
        if (hit) {
          say(esc(hit.a())).then(function () {
            choices([
              { label: 'Merci, c\'est clair', go: function () { say('Avec plaisir ! Bonne visite 🙂'); } },
              { label: 'Écrire à l\'équipe', go: function () { draft.subject = 'Question'; draft.body = v; send(); } },
              { label: 'Autre question', go: question }
            ]);
          });
        } else {
          draft.subject = 'Question'; draft.body = v;
          say('Je n\'ai pas la réponse toute prête : je transmets votre question à l\'équipe, qui vous répond par e-mail.').then(send);
        }
      }, { required: true });
    });
  }
  function start() {
    if (started) return;
    started = true;
    var name = cfg.customer ? ' ' + esc(cfg.customer) : '';
    if (cfg.order) {
      say('Bonjour' + name + ' ! Je prends des nouvelles : votre commande ' + esc(cfg.order.name) + (cfg.order.item ? ' (' + esc(cfg.order.item) + ')' : '') + ', tout se passe bien ?', 300).then(function () {
        choices([
          { label: 'Oui, ravi(e) 😍', go: happy },
          { label: 'Pas encore reçue', go: tracking },
          { label: 'Un souci avec ma montre', go: defect },
          { label: 'Autre chose', go: menu }
        ]);
      });
    } else {
      say('Bonjour' + name + ' ! Comment se passe votre visite chez nous ?', 300).then(menu);
    }
  }

  // ---------------------------------------------------------------- open / close
  function open(state) {
    panel.hidden = !state;
    root.classList.toggle('is-open', state);
    toggles[0].setAttribute('aria-expanded', state ? 'true' : 'false');
    nudge.hidden = true;
    if (state) start();
  }
  Array.prototype.forEach.call(toggles, function (t) { t.addEventListener('click', function () { open(panel.hidden); }); });
  nudge.addEventListener('click', function () { open(true); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) open(false); });

  // Back from a successful send
  if (root.querySelector('[data-cg-posted]') || (/contact_posted=true/.test(location.search) && ls.get('useit-cg-sent') && Date.now() - parseInt(ls.get('useit-cg-sent'), 10) < 120000)) {
    ls.set('useit-cg-sent', '0');
    open(true);
    started = true;
    say('C\'est envoyé, merci ! L\'équipe vous répond par e-mail si besoin. Bonne journée 🙂', 200);
    return;
  }

  // Gentle check-in: once per order for customers, once per visit otherwise
  var key = cfg.order ? 'useit-cg-order-' + cfg.order.name : 'useit-cg-visit';
  var seen = cfg.order ? ls.get(key) : (function () { try { return sessionStorage.getItem(key); } catch (e) { return '1'; } })();
  if (!seen) {
    setTimeout(function () {
      if (!panel.hidden) return;
      nudge.textContent = cfg.order ? 'Votre commande ' + cfg.order.name + ' : tout va bien ?' : 'Bonjour 👋 Tout se passe bien ?';
      nudge.hidden = false;
      if (cfg.order) ls.set(key, '1'); else { try { sessionStorage.setItem(key, '1'); } catch (e) {} }
    }, cfg.order ? 2500 : (cfg.delay || 25000));
  }
})();
